import sanitizeHtml from 'sanitize-html';

/** Formatting tags used in imported ticket HTML (Asana/Jira) and policy copy. */
const ALLOWED_TAGS = [
  'p',
  'br',
  'div',
  'span',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'strike',
  'del',
  'ins',
  'code',
  'pre',
  'blockquote',
  'ul',
  'ol',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'a',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td',
  'caption',
  'hr',
  'sub',
  'sup',
];

const ALLOWED_SCHEMES = ['http', 'https', 'mailto'];

/**
 * Allowlist sanitizer for HTML rendered via `dangerouslySetInnerHTML`.
 * Strips scripts, event-handler attributes, and non-http(s)/mailto URLs.
 */
export function sanitizeRichHtml(html: string): string {
  if (!html) return '';

  return sanitizeHtml(html, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
    },
    allowedSchemes: ALLOWED_SCHEMES,
    allowedSchemesByTag: { a: ALLOWED_SCHEMES },
    allowedSchemesAppliedToAttributes: ['href'],
    allowProtocolRelative: false,
    nonTextTags: ['script', 'style', 'textarea', 'option', 'noscript'],
    transformTags: {
      a: (_tagName, attribs) => ({
        tagName: 'a',
        attribs: {
          ...(attribs.href ? { href: attribs.href } : {}),
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      }),
    },
  });
}
